module.exports = __webpack_public_path__ + "static/img/ls.eb8bab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ls.png
// module id = ZCRl
// module chunks = 0